module.exports = __webpack_public_path__ + "static/media/spinner.8b5b449c.gif";